<mpro-loading *ngIf="options.loading"></mpro-loading>
<div *ngIf="options.title" class="title-wrapper">
  <h5>{{ options.title }}</h5>
  <fa-icon *ngIf="options.showLock" [icon]="faLock"></fa-icon>
</div>
<div [ngSwitch]="options.type">
  <div *ngSwitchCase="'chart'" class="chart">
    <p>{{ options.chartDescription }}</p>
    <strong>{{ options.chartText }}</strong>
    <p>{{ options.chartCaption }}</p>
  </div>

  <div *ngSwitchCase="'map'" class="map">
    <div class="flexed">
      <div *ngIf="options.people !== undefined">
        <p>
          <strong>{{ options.people | formatNumber : true }}</strong> people
        </p>
        <!-- <p class="small">{{options.peopleCaption}}% of {{ formatNumber(options.peopleCaptionTotal, 2) }}</p> -->
      </div>
      <div *ngIf="options.spending !== undefined">
        <p>
          spending
          <strong>${{ options.spending | formatNumber : true }}</strong>
        </p>
        <!-- <p class="small">{{options.spendingCaption}}% of {{ formatNumber(options.spendingCaptionTotal, 2) }}</p> -->
      </div>
    </div>
    <p *ngIf="options.dailySpending !== undefined">
      <strong
        >${{ options.dailySpending | formatNumber : false : ".2-2" }}</strong
      >
      annual spending per capita
    </p>
    <!-- <p><strong #growthText [ngClass]="{'positive': growth >= 0, 'negative' : growth < 0 }">{{options.growth}}%</strong> market growth</p> -->
  </div>

  <div *ngSwitchCase="'interactive'" class="interactive">
    <p>{{ options.interactiveText }}</p>
    <div class="flexed">
      <button
        class="mpro-btn"
        color="gray"
        hue="100"
        mproButtton="tertiary"
        (click)="backClick()"
      >
        {{ options.interactiveLeft }}
      </button>
      <button class="mpro-btn mpro-btn-tertiary" (click)="nextClick()">
        {{ options.interactiveRight }}
      </button>
    </div>
  </div>

  <div *ngSwitchCase="'data-explorer'">
    <p>{{ options.interactiveText }}</p>
  </div>
</div>
